import { gql } from '@apollo/client'

export const UPDATE_REVISION = gql`
    mutation EditRevisionDescription($input: updateRevisionInput!) {
        updateRevision(input: $input) {
            __typename
            guid
            description
        }
    }
`
